import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["track"];

    connect() {
        this.trackTarget.addEventListener("animationend", () => {
            // Restart на анимацията
            this.trackTarget.classList.remove("marquee-track");
            void this.trackTarget.offsetWidth; // 🧠 reflow трик за рестарт
            this.trackTarget.classList.add("marquee-track");
        });
    }
}
